<template>
  <div class="panel-section">
    <h3 class="section-title">{{ $t('overview.quickActions.title') }}</h3>
    <div class="quick-actions" v-if="actionButtons.length" v-loading="loading">
      <el-button
        v-for="(item, index) in actionButtons"
        :key="index"
        class="action-btn"
        @click="goPage(item)"
      >
        {{ item.ticketTemplateName }}
      </el-button>
    </div>
    <el-empty v-else :description="$t('text.noSearch')" :image-size="70"></el-empty>
  </div>
</template>

<script>
import submit from '../../../workSheet/SubmitWorkSheet';
export default {
  name: 'QuickActions',
  data() {
    return {
      actionButtons: [],
      loading: false,
    }
  },
  mounted() {
    this.getTicketData();
  },

  methods: {
    goPage(item) {
      const route = submit.methods.getRoute(item);
      this.$router.push({ 
        path: route,
        query: {
          idcLine: this.GLOBAL.idcLine,
          ticketNo: item.ticketNo
        }
      });
    },
    getTicketData() {
      this.loading = true;
      this.$api.getTicketData().then(res => {
        if (res.errno === 10000 && res.data && res.data.topTicketTemplates) {
          this.actionButtons = res.data.topTicketTemplates;
        }
      }).finally(() => {
        this.loading = false
      })
    }
  },
}
</script>

<style lang="scss" scoped>
.panel-section {
  background: #fff;
  padding: 24px;
  border-radius: 8px;
  
  .section-title {
      font-size: 14px;
      font-weight: 600;
      color: rgba(0, 0, 0, 0.85);
      margin: 0 0 16px 0;
  }

  // Quick Actions
  .quick-actions {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 20px;

    .action-btn {
      background: rgba(0, 0, 0, 0.02);
      border: none;
      padding: 12px;
      border-radius: 4px;
      color: rgba(0, 0, 0, 0.65);
      cursor: pointer;
      transition: all 0.3s;
      font-size: 13px;

      &:hover {
        background: #e6f1fc;
        color: #1D41FF;
      }
    }
  }
}
.el-button + .el-button {
  margin-left: 0px !important;
}
</style>


// WEBPACK FOOTER //
// src/components/resourceOverview/components/sidePanelComponents/QuickActions.vue